//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Pages.  NOTE: Some of these are referenced in Migrations to avoid string-typos. */
export const Page = {
    /**
     * Gets the Ability Levels page guid
     * ParentPage: Check-in
     */
    AbilityLevels: "9DD78A23-BE4B-474E-BCBC-F06AAABB67FA",
    /**
     * Gets the Ability Select page guid
     * ParentPage: Check-in
     */
    AbilitySelect: "A1CBDAA4-94DD-4156-8260-5A3781E39FD0",
    /**
     * Gets the Account page guid
     * ParentPage: Rock Shop
     */
    Account: "DADE879D-8DF5-4367-89EF-FEECD12B81AB",
    /**
     * Gets the Account Detail page guid
     * ParentPage: Accounts
     */
    AccountDetail: "75130E27-405A-4935-AB27-0EDE11F6E8B3",
    /**
     * Gets the Accounts page guid
     * ParentPage: Administration
     */
    Accounts: "2B630A3B-E081-4204-A3E4-17BB3A5F063D",
    /**
     * Gets the Achievement Type page guid
     * ParentPage: Rock.SystemGuid.Page.ENGAGEMENT
     */
    AchievementTypes: "FCE0D006-F854-4107-9298-667563FA8D77",
    /**
     * Gets the Add Transaction page guid
     * ParentPage: Contributions
     */
    AddTransaction: "B1CA86DC-9890-4D26-8EBD-488044E1B3DD",
    /**
     * Gets the Admin page guid
     * ParentPage: Check-in
     */
    AdminCheckIn: "7B7207D0-B905-4836-800E-A24DDC6FE445",
    /**
     * Gets the Admin Tools page guid
     * ParentPage: Internal Homepage
     */
    AdminTools: "84E12152-E456-478E-AF68-BA640E9CE65B",
    /**
     * Gets the Administration page guid
     * ParentPage: Finance
     */
    AdministrationFinance: "18C9E5C3-3E28-4AA3-84F6-78CD4EA2DD3C",
    /** The apple tv application detail */
    AppleTvApplicationDetail: "ED4341EB-3846-48B4-96D3-444D3ABBF389",
    /** The apple tv application screen detail */
    AppleTvApplicationScreenDetail: "6CC8D008-8D30-416D-8A36-7D01B72A2518",
    /** The apple tv apps */
    AppleTvApps: "C8B81EBE-E98F-43EF-9E39-0491685145E2",
    /**
     * Gets the Application Group Detail page guid
     * ParentPage: Application Groups
     */
    ApplicationGroupDetail: "E9737442-E6A9-47D5-A842-11C1AE1CF43F",
    /**
     * Gets the Application Groups page guid
     * ParentPage: System Settings
     */
    ApplicationGroups: "BA078BB8-7205-46F4-9530-B2FB9EAD3E57",
    /**
     * Gets the Attendance page guid
     * ParentPage: Group Attendance
     */
    Attendance: "D2A75147-B031-4DF7-8E04-FDDEAE2575F1",
    /**
     * Gets the Attendance Analysis page guid
     * ParentPage: Reporting
     */
    AttendanceAnalysis: "7A3CF259-1090-403C-83B7-2DB3A53DEE26",
    /**
     * Gets the Attribute Categories page guid
     * ParentPage: General Settings
     */
    AttributeCategories: "220D72F5-B589-4378-9852-BBB6F145AD7F",
    /**
     * Gets the Audit Information page guid
     * ParentPage: Security
     */
    AuditInformation: "4D7F3953-0BD9-4B4B-83F9-5FCC6B2BBE30",
    /**
     * Gets the Authentication Services page guid
     * ParentPage: Security
     */
    AuthenticationServices: "CE2170A9-2C8E-40B1-A42E-DFA73762D01D",
    /**
     * Gets the Background Check Providers page guid
     * ParentPage: System Settings
     */
    BackgroundCheckProviders: "53F1B7D9-806A-4541-93BC-4CCF5DFF90B3",
    /**
     * Gets the Badge Detail page guid
     * ParentPage: Person Profile Badges
     */
    BadgeDetail: "D376EFD7-5B0D-44BF-A44D-03C466D2D30D",
    /**
     * Gets the Badges page guid
     * ParentPage: General Settings
     */
    Badges: "26547B83-A92D-4D7E-82ED-691F403F16B6",
    /**
     * Gets the Batches page guid
     * ParentPage: Functions
     */
    Batches: "EF65EFF2-99AC-4081-8E09-32A04518683A",
    /**
     * Gets the Benevolence Detail page guid
     * ParentPage: Benevolence
     */
    BenevolenceDetail: "6DC7BAED-CA01-4703-B679-EC81143CDEDD",
    /**
     * Gets the Benevolence page guid
     * ParentPage: Functions
     */
    BenevolenceFunctions: "D893CCCC-368A-42CF-B36E-69991128F016",
    /**
     * Gets the Benevolence page guid
     * ParentPage: Person Pages
     */
    BenevolencePersonPages: "15FA4176-1C8E-409D-8B47-85ADA35DE5D2",
    /**
     * Gets the Benevolence Request Detail page guid
     * ParentPage: Benevolence
     */
    BenevolenceRequestDetail: "648CA58C-EB12-4479-9994-F064070E3A32",
    /**
     * Gets the Benevolence Types page guid
     * ParentPage: Benevolence
     */
    BenevolenceTypes: "C6BE9CF1-FFE9-4DC1-8472-865FD93B89A8",
    /**
     * Gets the Benevolence Types Detail page guid
     * ParentPage: Benevolence
     */
    BenevolenceTypesDetail: "DBFC432E-F0A4-457E-BA5B-572C49B899D1",
    /**
     * Gets the Block Properties page guid
     * ParentPage: System Dialogs
     */
    BlockProperties: "F0B34893-9550-4864-ADB4-EE860E4E427C",
    /**
     * Gets the Block Type Detail page guid
     * ParentPage: Block Types
     */
    BlockTypeDetail: "C694AD7C-46DD-47FE-B2AC-1CF158FA6504",
    /**
     * Gets the Block Types page guid
     * ParentPage: CMS Configuration
     */
    BlockTypes: "5FBE9019-862A-41C6-ACDC-287D7934757D",
    /**
     * Gets the Blog page guid
     * ParentPage: External Homepage
     */
    Blog: "4857A6C9-F194-4B64-A9FB-6A8DC7A1A671",
    /**
     * Gets the Blog Details page guid
     * ParentPage: Blog
     */
    BlogDetails: "2D0D0FB0-68C4-47E1-8BC6-98F931497F5E",
    /**
     * Gets the Bulk Update page guid
     * ParentPage: Support Pages
     */
    BulkUpdate: "B6BFDE54-0EFA-4499-847D-BE1259F83535",
    /**
     * Gets the bus page guid
     * ParentPage: System Settings
     */
    Bus: "0FF43CC8-1C29-4882-B2F6-7B6F4C25FE41",
    /**
     * Gets the Transport page guid
     * ParentPage: Bus
     */
    BusQueue: "45E865C0-CD2D-43CD-AA8A-BF5DBF537587",
    /**
     * Gets the Transport page guid
     * ParentPage: Bus
     */
    BusTransport: "10E34A5D-D967-457D-9DF1-A1D33DA9D100",
    /**
     * Gets the Business Detail page guid
     * ParentPage: Businesses
     */
    BusinessDetail: "D2B43273-C64F-4F57-9AAE-9571E1982BAC",
    /**
     * Gets the Businesses page guid
     * ParentPage: Administration
     */
    Businesses: "F4DF4899-2D44-4997-BA9B-9D2C64958A20",
    /**
     * Gets the Calendars page guid
     * ParentPage: Website
     */
    Calendars: "63990874-0DFF-45FC-9F09-81B0B0D375B4",
    /**
     * Gets the Campus Detail page guid
     * ParentPage: Campuses
     */
    CampusDetail: "BDD7B906-4D42-43C0-8DBB-B89A566734D8",
    /**
     * Gets the Campuses page guid
     * ParentPage: General Settings
     */
    Campuses: "5EE91A54-C750-48DC-9392-F1F0F0581C3A",
    /**
     * Gets the Change Password page guid
     * ParentPage: My Settings
     */
    ChangePasswordMySettings: "4508223C-2989-4592-B764-B3F372B6051B",
    /**
     * Gets the Check-in Configuration page guid
     * ParentPage: Check-in
     */
    CheckInConfiguration: "C646A95A-D12D-4A67-9BE6-C9695C0267ED",
    /**
     * Gets the Check-in Label page guid
     * ParentPage: Check-in Labels
     */
    CheckInLabel: "B565FDF8-959F-4AC8-ACDF-3B1B5CFE79F5",
    /**
     * Gets the Check-in Labels page guid
     * ParentPage: Check-in
     */
    CheckInLabels: "7C093A63-F2AC-4FE3-A826-8BF06D204EA2",
    /**
     * Gets the Check-in Manager page guid
     * ParentPage: Check-in Type
     */
    CheckInManager: "A4DCE339-9C11-40CA-9A02-D2FE64EA164B",
    /** The check in manager attendance detail */
    CheckInManagerAttendanceDetail: "758ECFCD-9E20-48B5-827B-973492E39C0D",
    /** The Check-in Manager En Route page */
    CheckInManagerEnRoute: "F6466964-6593-4B20-A49B-D2386D8A260C",
    /** The Check-in Manager Live Metrics page */
    CheckInManagerLiveMetrics: "04F70D50-5D27-4C12-A76D-B25E6E4CB177",
    /** The Login page under the Check-in Manager page */
    CheckInManagerLogin: "31F51DBB-AC84-4724-9219-B46FADAB9CB2",
    /** The Logout page under the Check-in Manager page */
    CheckInManagerLogout: "9762DE9F-F431-4108-9F1A-AE88DFEB3289",
    /** The check in manager person attendance change history */
    CheckInManagerPersonAttendanceChangeHistory: "185BFEA9-9E95-4B8D-836B-87AF36BE6109",
    /** The check in manager room list page */
    CheckInManagerRoomList: "CF03D854-AC02-412C-9B21-FB27B9F56BAB",
    /** The Check-in Manager room manager page */
    CheckInManagerRoomManager: "CECB1460-10D4-4054-B5C3-903991CA40AB",
    /** The Check-in Manager room settings page (Where rooms can be open/closed) */
    CheckInManagerRoomSettings: "0416FF62-3252-4A84-85DB-79F4CAE82C75",
    /** The Check-in Manager roster page */
    CheckInManagerRoster: "BA04BF01-5244-4637-B12D-7A962D2A9E77",
    /** The Check-in Manager search page */
    CheckInManagerSearch: "5BB14114-BE20-4330-943A-5BC7E367116E",
    /** The Settings page under the Check-in Manager page (Where Check-in Configuration is selected) */
    CheckInManagerSettings: "62C70118-0A6F-432A-9D84-A5296655CB9E",
    /**
     * Gets the Check-in page guid
     * ParentPage: Rock Settings
     */
    CheckInRockSettings: "66C5DD58-094C-4FF9-9AFB-44801FCFCC2D",
    /**
     * Gets the Check-in page guid
     * ParentPage: 
     */
    CheckInRoot: "CDF2C599-D341-42FD-B7DC-CD402EA96050",
    /**
     * Gets the Check-in Type page guid
     * ParentPage: 
     */
    CheckInType: "62C70118-0A6F-432A-9D84-A5296655CB9E",
    /**
     * Gets the Ability Select page guid
     * ParentPage: Check-in
     */
    CheckinAbilitySelect: "A1CBDAA4-94DD-4156-8260-5A3781E39FD0",
    /**
     * Gets the Action Select page guid
     * ParentPage: Check-in
     */
    CheckinActionSelect: "0586648B-9490-43C6-B18D-7F403458C080",
    /**
     * Gets the Admin page guid
     * ParentPage: Check-in
     */
    CheckinAdmin: "7B7207D0-B905-4836-800E-A24DDC6FE445",
    /**
     * Gets the Check Out Person Select page guid
     * ParentPage: Check-in
     */
    CheckinCheckOutPersonSelect: "D54FC289-DF7D-48C5-91BE-38BCFDEBC6AF",
    /**
     * Gets the Check Out Success page guid
     * ParentPage: Check-in
     */
    CheckinCheckOutSuccess: "21A855BA-6D68-4504-97B4-D787452CEC29",
    /**
     * Gets the Family Select page guid
     * ParentPage: Check-in
     */
    CheckinFamilySelect: "10C97379-F719-4ACB-B8C6-651957B660A4",
    /**
     * Gets the Group Select page guid
     * ParentPage: Check-in
     */
    CheckinGroupSelect: "6F0CB22B-E05B-42F1-A329-9219E81F6C34",
    /**
     * Gets the Group Type Select page guid
     * ParentPage: Check-in
     */
    CheckinGroupTypeSelect: "60E3EA1F-FD6B-4F0E-9C72-A9960E13427C",
    /**
     * Gets the Location Select page guid
     * ParentPage: Check-in
     */
    CheckinLocationSelect: "043BB717-5799-446F-B8DA-30E575110B0C",
    /**
     * Gets the Person Select page guid
     * ParentPage: Check-in
     */
    CheckinPersonSelect: "BB8CF87F-680F-48F9-9147-F4951E033D17",
    /**
     * Gets the Person Select (Family Check-in) page guid
     * ParentPage: Check-in
     */
    CheckinPersonSelectFamilyCheckIn: "D14154BA-2F2C-41C3-B380-F833252CBB13",
    /**
     * Gets the Save Attendance (Family Check-in) page guid
     * ParentPage: Check-in
     */
    CheckinSaveAttendanceFamilyCheckIn: "4AF7A0E1-E991-4AE5-A2B5-C440F67A2E6A",
    /**
     * Gets the Scheduled Locations page guid
     * ParentPage: Check-in
     */
    CheckinScheduledLocations: "4E210ABB-65B3-4816-BD77-D2C876FC0FD5",
    /**
     * Gets the Search page guid
     * ParentPage: Check-in
     */
    CheckinSearch: "D47858C0-0E6E-46DC-AE99-8EC84BA5F45F",
    /**
     * Gets the Success page guid
     * ParentPage: Check-in
     */
    CheckinSuccess: "E08230B8-35A4-40D6-A0BB-521418314DA9",
    /**
     * Gets the Time Select page guid
     * ParentPage: Check-in
     */
    CheckinTimeSelect: "C0AFA081-B64E-4006-BFFC-A350A51AE4CC",
    /**
     * Gets the Time Select (Family Check-in) page guid
     * ParentPage: Check-in
     */
    CheckinTimeSelectFamilyCheckIn: "67BD09B0-0C6E-44E7-A8EB-0E71551F3E6B",
    /**
     * Gets the Welcome page guid
     * ParentPage: Check-in
     */
    CheckinWelcome: "432B615A-75FF-4B14-9C99-3E769F866950",
    /**
     * Gets the ChildPages page guid
     * ParentPage: System Dialogs
     */
    Childpages: "D58F205E-E9CC-4BD9-BC79-F3DA86F6E346",
    /**
     * Gets the CMS Configuration page guid
     * ParentPage: Rock Settings
     */
    CmsConfiguration: "B4A24AB7-9369-4055-883F-4F4892C39AE3",
    /**
     * Gets the Communication page guid (stock external page)
     * ParentPage: Support Pages
     */
    Communication: "60002BC0-790A-4052-8F8D-B08C2C5D261C",
    /**
     * Gets the Communication History page guid
     * ParentPage: Communications
     */
    CommunicationHistory: "CADB44F2-2453-4DB5-AB11-DADA5162AB79",
    /**
     * Gets the Communication Mediums page guid
     * ParentPage: Communications
     */
    CommunicationMediums: "6FF35C53-F89F-4601-8543-2E2328C623F8",
    /**
     * Gets the Communication Templates page guid
     * ParentPage: Communications
     */
    CommunicationTemplatesCommunications: "39F75137-90D2-4E6F-8613-F19344767594",
    /**
     * Gets the Communication Templates page guid
     * ParentPage: My Settings
     */
    CommunicationTemplatesMySettings: "EA611245-7A5E-4995-A3C6-EB97C6FD7C8D",
    /**
     * Gets the Communication Transports page guid
     * ParentPage: Communications
     */
    CommunicationTransports: "29CC8A0B-6476-4200-8B93-DC9BA8767D59",
    /**
     * Gets the Communications page guid
     * ParentPage: People
     */
    CommunicationsPeople: "7F79E512-B9DB-4780-9887-AD6D63A39050",
    /**
     * Gets the Communications page guid
     * ParentPage: Rock Settings
     */
    CommunicationsRockSettings: "199DC522-F4D6-4D82-AF44-3C16EE9D2CDA",
    /**
     * Gets the Configuration page guid
     * ParentPage: Check-in Configuration
     */
    Configuration: "4AB679AF-C8CC-427C-A615-0BF9F52E8E3E",
    /**
     * Gets the Confirm page guid
     * ParentPage: Security
     */
    Confirm: "D73F83B4-E20E-4F95-9A2C-511FB669F44C",
    /**
     * Gets the Connections opportunity select page guid.
     * ParentPage: Engagement
     */
    ConnectionOpportunitySelect: "2A0C135A-8421-4125-A484-83C8B4FB3D34",
    /** The connection request detail page guid */
    ConnectionRequestDetail: "50f04e77-8d3b-4268-80ab-bc15dd6cb262",
    /** The connection requests bulk update page */
    ConnectionRequestsBulkUpdate: "1F5D34CF-89C1-426C-A139-83D87905D669",
    /**
     * Connection Type Config Page
     * ParentPage: Connections
     */
    ConnectionTypes: "9CC19684-7AD2-4D4E-A7C4-10DAE56E7FA6",
    /**
     * Gets the Connections page guid. This was the original connections root page that was replaced by
     * the connection opportunity select.
     * ParentPage: Connections opportunity select
     */
    Connections: "530860ED-BC73-4A43-8E7C-69533EF2B6AD",
    /**
     * Gets the Connections board page guid.
     * ParentPage: Connections opportunity select
     */
    ConnectionsBoard: "4FBCEB52-8892-4035-BDEA-112A494BE81F",
    /**
     * Gets the Contact Us page guid
     * ParentPage: Connect
     */
    ContactUs: "B1E63FE3-779C-4388-AFE4-FD6DFC034932",
    /**
     * Gets the Content page guid
     * ParentPage: Website
     */
    Content: "117B547B-9D71-4EE9-8047-176676F5DC8C",
    /**
     * Gets the Content Channel Detail page guid
     * ParentPage: Content Channels
     */
    ContentChannelDetail: "4AE244F5-A5BF-48CF-B53B-785148EC367D",
    /**
     * Gets the Content Channel Types page guid
     * ParentPage: CMS Configuration
     */
    ContentChannelTypes: "37E3D602-5D7D-4818-BCAA-C67EBB301E55",
    /**
     * Gets the Content Channels page guid
     * ParentPage: CMS Configuration
     */
    ContentChannels: "8ADCE4B2-8E95-4FA3-89C4-06A883E8145E",
    /**
     * Gets the Content Detail page guid
     * ParentPage: Content
     */
    ContentDetail: "D18E837C-9E65-4A38-8647-DFF04A595D97",
    /**
     * Gets the Content Item Detail page guid
     * ParentPage: Content Channel Detail
     */
    ContentItemDetail: "ABF26679-1051-4F4F-8A67-5958E5BF71F8",
    /**
     * Gets the Content Type Detail page guid
     * ParentPage: Content Channel Types
     */
    ContentTypeDetail: "91EAB2A2-4D44-4701-9ABE-37AE3E7A1B8F",
    /** The Contribution Statement Page on the stock external site */
    ContributionStatementPage: "98EBADAF-CCA9-4893-9DD3-D8201D8BD7FA",
    /**
     * Gets the Contributions page guid
     * ParentPage: Person Pages
     */
    Contributions: "53CF4CBE-85F9-4A50-87D7-0D72A3FB2892",
    /**
     * Gets the Data Filters page guid
     * ParentPage: System Settings
     */
    DataFilters: "5537F375-B652-4603-8E04-119C74414CD7",
    /**
     * Gets the Data Integrity page guid
     * ParentPage: Reporting
     */
    DataIntegrity: "84FD84DF-F58B-4B9D-A407-96276C40AB7E",
    /**
     * Gets the Data Selects page guid
     * ParentPage: System Settings
     */
    DataSelects: "227FDFB9-8C29-4B34-ABE5-E0579A3A6018",
    /**
     * Gets the Data Transformations page guid
     * ParentPage: System Settings
     */
    DataTransformations: "9C569E6B-F745-40E4-B91B-A518CD6C2922",
    /**
     * Gets the Data Views page guid
     * ParentPage: Reporting
     */
    DataViews: "4011CB37-28AA-46C4-99D5-826F4A9CADF5",
    /** The dataview search results page */
    DataviewSearchResults: "6C7AB3CA-E894-4E19-96AE-C67C4C69FEDE",
    /**
     * Gets the Defined Type Detail page guid
     * ParentPage: Defined Types
     */
    DefinedTypeDetail: "60C0C193-61CF-4B34-A0ED-67EF8FD44867",
    /**
     * Gets the Defined Types page guid
     * ParentPage: General Settings
     */
    DefinedTypes: "E0E1DE66-B825-4BFB-A0B3-6E069AA9AA40",
    /**
     * Gets the Devices page guid
     * ParentPage: Check-in
     */
    DevicesCheckIn: "5A06C807-251C-4155-BBE7-AAC73D0745E3",
    /**
     * Gets the Devices page guid
     * ParentPage: General Settings
     */
    DevicesGeneralSettings: "7E660A4D-72C5-4CF8-B144-16CFC2ADD4D7",
    /**
     * Gets the DISC Assessment page guid
     * ParentPage: Support Pages
     */
    DiscAssessment: "C8CEF4B0-4A09-46D2-9B6B-CD2B6D3078B1",
    /**
     * Gets the DISC Result page guid
     * ParentPage: Person Profile
     */
    DiscResult: "039F770B-5734-4735-ABF1-B39B77C84AD0",
    /**
     * Gets the Download Payments page guid
     * ParentPage: Administration
     */
    DownloadPayments: "720819FC-1730-444A-9DE8-C98D29954170",
    /**
     * Gets the Duplicate Detail page guid
     * ParentPage: Duplicate Finder
     */
    DuplicateDetail: "6F9CE971-75DF-4F2A-BD5E-A12B149A442E",
    /**
     * Gets the Duplicate Finder page guid
     * ParentPage: Data Integrity
     */
    DuplicateFinder: "21E94BF1-C594-44B6-AD91-939ABD04D36E",
    /**
     * Gets the Edit Family page guid
     * ParentPage: Person Profile
     */
    EditFamily: "E9E1E5F2-467D-47CB-AF41-B4D9EF8B0B27",
    /**
     * Gets the Edit My Account page guid
     * ParentPage: My Account
     */
    EditMyAccount: "4A4655D1-BDD9-4ECE-A3F6-B655F0BDF9F5",
    /**
     * Gets the Edit Person page guid
     * ParentPage: Person Profile
     */
    EditPerson: "AD899394-13AD-4CAB-BCB3-CFFD79C9ADCC",
    /**
     * Gets the Edit Scheduled Transaction page guid
     * ParentPage: Contributions
     */
    EditScheduledTransactionContributions: "D360B64F-1267-4518-95CD-99CD5AB87D88",
    /**
     * Gets the Edit Scheduled Transaction page guid
     * ParentPage: Scheduled Transaction
     */
    EditScheduledTransactionScheduledTransaction: "F1C3BBD3-EE91-4DDD-8880-1542EBCD8041",
    /** Gets the Email Analytics page guid */
    EmailAnalytics: "DF014200-72A3-48A0-A953-E594E5410E36",
    /**
     * Gets the Email Preference page guid
     * ParentPage: Support Pages
     */
    EmailPreference: "74317DFD-F10D-4347-8E6A-CCD0FAFE31D7",
    /**
     * Gets the Employee Details page guid
     * ParentPage: Org Chart
     */
    EmployeeDetails: "DA8E33F3-2EEF-4C4B-87F3-715C3F107CAF",
    /**
     * Gets the Engagement page guid
     * ParentPage: People &gt; Manage
     */
    Engagement: "48242949-944A-4651-B6CC-60194EDE08A0",
    /**
     * Gets the Entity Administration page guid
     * ParentPage: Security
     */
    EntityAdministration: "F7F41856-F7EA-49A8-9D9B-917AC1964602",
    /**
     * Gets the Entity Attributes page guid
     * ParentPage: Security
     */
    EntityAttributes: "23507C90-3F78-40D4-B847-6FE8941FCD32",
    /**
     * Gets the Event Calendar page guid
     * ParentPage: Calendars
     */
    EventCalendar: "B54725E1-3640-4419-B580-2AF77DAF6568",
    /**
     * Gets the Event Detail page guid
     * ParentPage: Event Calendar
     */
    EventDetail: "7FB33834-F40A-4221-8849-BB8C06903B04",
    /**
     * Gets the Event Details page guid
     * ParentPage: Calendar
     */
    EventDetails: "8A477CC6-4A12-4FBE-8037-E666476DD413",
    /**
     * Gets the Event Occurrence page guid
     * ParentPage: Event Detail
     */
    EventOccurrence: "4B0C44EE-28E3-4753-A95B-8C57CD958FD1",
    /**
     * Gets the Event Registration page guid
     * ParentPage: Website
     */
    EventRegistration: "614AF351-6C48-4B6B-B50E-9F7E03BC00A4",
    /**
     * Gets the Exception Detail page guid
     * ParentPage: Exception List
     */
    ExceptionDetail: "F1F58172-E03E-4299-910A-ED34F857DAFB",
    /**
     * Gets the Exception List page guid
     * ParentPage: System Settings
     */
    ExceptionList: "21DA6141-0A03-4F00-B0A8-3B110FBE2438",
    /**
     * Gets the Extended Attributes page guid
     * ParentPage: Person Pages
     */
    ExtendedAttributes: "1C737278-4CBA-404B-B6B3-E3F0E05AB5FE",
    /**
     * Gets the External Applications page guid
     * ParentPage: Power Tools
     */
    ExternalApplications: "5A676DCC-37F0-4624-8CCD-408A5A471D8A",
    /**
     * Gets the External Homepage page guid
     * ParentPage: 
     */
    ExternalHomepage: "85F25819-E948-4960-9DDF-00F54D32444E",
    /**
     * Gets the external site's Workflow Entry page guid
     * ParentPage: Workflows
     */
    ExternalWorkflowEntry: "C58861DF-2D82-4E7A-AA5B-04165D2D34C2",
    /**
     * Gets the Family Select page guid
     * ParentPage: Check-in
     */
    FamilySelect: "10C97379-F719-4ACB-B8C6-651957B660A4",
    /**
     * Gets the File Storage Providers page guid
     * ParentPage: System Settings
     */
    FileStorageProviders: "FEA8D6FC-B26F-48D5-BE69-6BCEF7CDC4E5",
    /**
     * Gets the File Type page guid
     * ParentPage: File Types
     */
    FileType: "19CAC4D5-FE82-4AE0-BFD3-3C12E3024574",
    /**
     * Gets the File Types page guid
     * ParentPage: General Settings
     */
    FileTypes: "66031C31-B397-4F78-8AB2-389B7D8731AA",
    /**
     * Gets the Finance page guid
     * ParentPage: Internal Homepage
     */
    Finance: "7BEB7569-C485-40A0-A609-B0678F6F7240",
    /**
     * The financial account search guid
     * ParentPage: Internal Homepage &gt; Finance &gt; Administration
     */
    FinancialAccountSearch: "7A36463B-8E63-4394-BE20-ECFC5970080C",
    /**
     * Gets the Financial Batch Detail page guid
     * ParentPage: Batches
     */
    FinancialBatchDetail: "606BDA31-A8FE-473A-B3F8-A00ECF7E06EC",
    /**
     * Gets the Financial Gateways page guid
     * ParentPage: System Settings
     */
    FinancialGateways: "F65AA215-8B46-4E34-B709-FA956BF62C30",
    /** The financial settings menu page on the internal Rock page */
    FinancialSettings: "90723727-56EC-494D-9708-E188869D900C",
    /**
     * Gets the Following page guid
     * ParentPage: Manage
     */
    Following: "A6AE67F7-0B46-4F9A-9C96-054E1E82F784",
    /**
     * Gets the Forgot User Name page guid
     * ParentPage: Security
     */
    ForgotUserName: "C6628FBD-F297-4C23-852E-40F1369C23A8",
    /**
     * Gets the Functions page guid
     * ParentPage: Finance
     */
    FunctionsFinance: "142627AE-6590-48E3-BFCA-3669260B8CF2",
    /**
     * Gets the Gateway Detail page guid
     * ParentPage: Financial Gateways
     */
    GatewayDetail: "24DE6092-CE91-468C-8E49-94DB3875B9B7",
    /**
     * Gets the General Settings page guid
     * ParentPage: Rock Settings
     */
    GeneralSettings: "0B213645-FA4E-44A5-8E4C-B2D8EF054985",
    /**
     * Gets the Give page guid (give now parent)
     * ParentPage: Give
     */
    Give: "8BB303AF-743C-49DC-A7FF-CC1236B4B1D9",
    /**
     * Gets the Give Now page guid
     * ParentPage: Give
     */
    GiveNow: "1615E090-1889-42FF-AB18-5F7BE9F24498",
    /** The giving alerts */
    GivingAlerts: "57650485-7727-4392-9C42-36DE50FBEEEA",
    /**
     * Gets the Global Attributes page guid
     * ParentPage: General Settings
     */
    GlobalAttributes: "A2753E03-96B1-4C83-AA11-FCD68C631571",
    /**
     * Gets the Group Attendance Detail page guid
     * ParentPage: Group Attendance
     */
    GroupAttendanceDetail: "0C00CD89-BF4C-4B19-9B0D-E1FA2CFF5DD7",
    /**
     * Gets the Group Attendance page guid
     * ParentPage: Group Toolbox
     */
    GroupAttendanceGroupToolbox: "00D2DCE6-D9C0-47A0-BAE1-4591779AE2E1",
    /**
     * Gets the Group Attendance page guid
     * ParentPage: Group Viewer
     */
    GroupAttendanceGroupViewer: "7EA94B4F-013B-4A79-8D01-86994EB04604",
    /** The group history grid page guid */
    GroupHistoryGrid: "FB9A6BC0-0B51-4A92-A32C-58AC822CD2D0",
    /**
     * Gets the Group Map page guid
     * ParentPage: Group Viewer
     */
    GroupMap: "60995C8C-862F-40F5-AFBB-13B49CDA77EB",
    /**
     * Gets the Group Member Detail page guid
     * ParentPage: Application Group Detail
     */
    GroupMemberDetailApplicationGroupDetail: "C920AA8F-A8CA-4984-95EC-58B7309E670E",
    /**
     * Gets the Group Member Detail page guid
     * ParentPage: Campus Detail
     */
    GroupMemberDetailCampusDetail: "EB135AE0-5BAC-458B-AD5B-47460C2BFD31",
    /**
     * Gets the Group Member Detail page guid
     * ParentPage: Group Viewer
     */
    GroupMemberDetailGroupViewer: "3905C63F-4D57-40F0-9721-C60A2F681911",
    /**
     * Gets the Group Member Detail page guid
     * ParentPage: Photo Request Application Group
     */
    GroupMemberDetailPhotoRequestApplicationGroup: "34491B77-E94D-4DA6-9E74-0F6086522E4C",
    /**
     * Gets the Group Member Detail page guid
     * ParentPage: Security Roles Detail
     */
    GroupMemberDetailSecurityRolesDetail: "45899E6A-7CEC-44EC-8DBA-BD8850262C04",
    /** The group member history page guid */
    GroupMemberHistory: "EAAB757E-524F-4DB9-A124-D5EFBCDCA63B",
    /**
     * Gets the Group Registration page guid
     * ParentPage: Small Groups
     */
    GroupRegistration: "7D24FE9A-710C-4B25-B1C7-76161ED78DB8",
    /**
     * Gets the Group RSVP Detail page guid
     * ParentPage:  Group RSVP List
     */
    GroupRsvpDetail: "40E60703-CF52-4742-BDA6-65FB0CF198CB",
    /**
     * Gets the Group RSVP List page guid
     * ParentPage:  Group Viewer
     */
    GroupRsvpList: "69285A6B-4DBB-43BB-8B0D-08DEBB860AEA",
    /**
     * Gets the Group RSVP Response page guid
     * ParentPage:  Support Pages (External Site)
     */
    GroupRsvpResponse: "7DF75851-A397-4C3B-A46F-DC3824A7ADC4",
    /**
     * Gets the Group Search Results page guid
     * ParentPage: Support Pages
     */
    GroupSearchResults: "9C9CAD94-095E-4CC9-BC29-24BDE30492B2",
    /**
     * Gets the Group Select page guid
     * ParentPage: Check-in
     */
    GroupSelect: "6F0CB22B-E05B-42F1-A329-9219E81F6C34",
    /**
     * Gets the Group Toolbox page guid
     * ParentPage: My Account
     */
    GroupToolbox: "4D84E1B1-6BA0-4F04-A9F3-DD07A6CF3F38",
    /**
     * Gets the Group Type Detail page guid
     * ParentPage: Group Types
     */
    GroupTypeDetail: "5CD8E024-710B-4EDE-8C8C-4C9E15E6AFAB",
    /**
     * Gets the Group Type Select page guid
     * ParentPage: Check-in
     */
    GroupTypeSelect: "60E3EA1F-FD6B-4F0E-9C72-A9960E13427C",
    /**
     * Gets the Group Types page guid
     * ParentPage: General Settings
     */
    GroupTypes: "40899BCD-82B0-47F2-8F2A-B6AA3877B445",
    /**
     * Gets the Group Viewer page guid
     * ParentPage: Manage
     */
    GroupViewer: "4E237286-B715-4109-A578-C1445EC02707",
    /**
     * Gets the Groups page guid
     * ParentPage: Person Pages
     */
    Groups: "183B7B7E-105A-4C9A-A4BC-06CD26B7FE6D",
    /**
     * Gets the History page guid
     * ParentPage: Person Pages
     */
    History: "BC8E5377-0F6C-457A-9CF0-0F0A0AB2A418",
    /**
     * Gets the History Categories page guid
     * ParentPage: System Settings
     */
    HistoryCategories: "95ACFF8C-B9EE-41C6-BAC0-D117D6E1FADC",
    /**
     * Gets the HTML Content Approval page guid
     * ParentPage: Website
     */
    HtmlContentApproval: "9DF95EFF-88B4-401A-8F5F-E3B8DB02A308",
    /** Gets the htmleditor RockAssetManager Plugin Frame page guid */
    HtmleditorRockassetmanagerPluginFrame: "DEB88EA2-D0CE-47B2-9EB3-FDDDAC2C3389",
    /**
     * Gets the HtmlEditor RockFileBrowser Plugin Frame page guid
     * ParentPage: System Dialogs
     */
    HtmleditorRockfilebrowserPluginFrame: "4A4995CA-24F6-4D33-B861-A24274F53AA6",
    /**
     * Gets the HtmlEditor RockMergeField Plugin Frame page guid
     * ParentPage: System Dialogs
     */
    HtmleditorRockmergefieldPluginFrame: "1FC09F0D-72F2-44E6-9D16-2884F9AF33DD",
    /**
     * Gets the Internal Homepage page guid
     * ParentPage: 
     */
    InternalHomepage: "20F97A93-7949-4C2A-8A5E-C756FE8585CA",
    /**
     * Gets the Item Detail page guid
     * ParentPage: Support Pages
     */
    ItemDetail: "56F1DC05-3D7D-49B6-9A30-5CF271C687F4",
    /**
     * Gets the Jobs Administration page guid
     * ParentPage: System Settings
     */
    JobsAdministration: "C58ADA1A-6322-4998-8FED-C3565DE87EFA",
    /**
     * Gets the Label Merge Fields page guid
     * ParentPage: Check-in
     */
    LabelMergeFields: "1DED4B72-1784-4781-A836-83D705B153FC",
    /**
     * Gets the LaunchWorkflow page guid
     * ParentPage: Workflows
     */
    Launchworkflow: "5DA89BC9-A185-4749-A843-314B72170D82",
    /**
     * Gets the Layout Detail page guid
     * ParentPage: Site Detail
     */
    LayoutDetail: "E6217A2B-B16F-4E84-BF67-795CA7F5F9AA",
    /**
     * Gets the Link Organization page guid
     * ParentPage: Rock Shop
     */
    LinkOrganization: "6E029432-56F4-46AD-9D9C-C122F3D3C55C",
    /**
     * Gets the Location Detail page guid
     * ParentPage: Location Editor
     */
    LocationDetail: "1602C1CA-2EC7-4163-B0E1-1FE7306AC2B4",
    /**
     * Gets the Location Editor page guid
     * ParentPage: Power Tools
     */
    LocationEditor: "47BFA50A-68D8-4841-849B-75AB3E5BCD6D",
    /**
     * Gets the Location Select page guid
     * ParentPage: Check-in
     */
    LocationSelect: "043BB717-5799-446F-B8DA-30E575110B0C",
    /**
     * Gets the Location Services page guid
     * ParentPage: System Settings
     */
    LocationServices: "1FD5698F-7279-463F-9637-9A80DB86BB86",
    /**
     * The login viewer
     * ParentPage: System Settings
     */
    LogViewer: "82EC7718-6549-4531-A0AB-7957919AE71C",
    /**
     * Gets the Login page guid
     * ParentPage: Security
     */
    LoginSecurity: "03CB988A-138C-448B-A43D-8891844EEB18",
    /**
     * Gets the Manage page guid
     * ParentPage: People
     */
    Manage: "B0F4B33D-DD11-4CCC-B79D-9342831B8701",
    /**
     * Gets the Manage Workflows page guid
     * ParentPage: Workflows
     */
    ManageWorkflows: "61E1B4B6-EACE-42E8-A2FB-37465E6D0004",
    /**
     * Gets the Mass Push Notifications page guid
     * ParentPage: Communications
     */
    MassPushNotifications: "3D97725E-5E17-411F-856C-F4B79B9BFF15",
    /**
     * Gets the Merge People page guid
     * ParentPage: Manage
     */
    MergePeople: "F0C4E25F-83DF-44FF-AB5A-EF6C3044FAD3",
    /**
     * Gets the Merge Template Detail page guid
     * ParentPage: Merge Templates
     */
    MergeTemplateDetail: "F29C7AF7-6436-4C4B-BD17-330A487A4BF4",
    /**
     * Gets the Merge Template Entry page guid
     * ParentPage: Support Pages
     */
    MergeTemplateEntry: "B864FBFD-3699-4DB5-A8A9-12B2FEA86C7A",
    /**
     * Gets the Merge Template Types page guid
     * ParentPage: System Settings
     */
    MergeTemplateTypes: "42717D07-3744-4187-89EC-F01EDD0FF5AD",
    /**
     * Gets the Merge Templates page guid
     * ParentPage: General Settings
     */
    MergeTemplatesGeneralSettings: "679AF013-0093-435E-AA49-E73B99EB9710",
    /**
     * Gets the Merge Templates page guid
     * ParentPage: My Settings
     */
    MergeTemplatesMySettings: "23F81A62-617A-498B-AAAC-D748F721176A",
    /**
     * Gets the Metric Value Detail page guid
     * ParentPage: Metrics
     */
    MetricValueDetail: "64E16878-D5AE-40A5-94FE-C2E8BE62DF61",
    /**
     * Gets the Metrics page guid
     * ParentPage: Reporting
     */
    Metrics: "78D84825-EB1A-43C6-9AD5-5F0F84CC9A53",
    /** The mobile site pages */
    MobileSitePages: "37E21200-DF91-4426-89CC-7D067237A037",
    /**
     * Gets the My Account page guid
     * ParentPage: Security
     */
    MyAccountSecurity: "290C53DC-0960-484C-B314-8301882A454C",
    /**
     * Gets the My Dashboard page guid
     * ParentPage: Internal Homepage
     */
    MyDashboard: "AE1818D8-581C-4599-97B9-509EA450376A",
    /**
     * Gets the My Settings page guid
     * ParentPage: Internal Homepage
     */
    MySettings: "CF54E680-2E02-4F16-B54B-A2F2D29CD932",
    /**
     * Gets the My Workflows page guid
     * ParentPage: Workflow
     */
    MyWorkflows: "F3FA9EBE-A540-4106-90E5-2DFB2D72BBF0",
    /**
     * Gets the Named Locations page guid
     * ParentPage: Check-in
     */
    NamedLocationsCheckIn: "96501070-BB46-4432-AA3C-A8C496691629",
    /**
     * Gets the Named Locations page guid
     * ParentPage: General Settings
     */
    NamedLocationsGeneralSettings: "2BECFB85-D566-464F-B6AC-0BE90189A418",
    /**
     * Gets the New Account page guid
     * ParentPage: Security
     */
    NewAccount: "7D4E2142-D24E-4DD2-84BC-B34C5C3D0D46",
    /**
     * Gets the New Communication page guid
     * ParentPage: Communications
     */
    NewCommunication: "2A22D08D-73A8-4AAF-AC7E-220E8B2E7857",
    /**
     * Gets the New Family page guid
     * ParentPage: Manage
     */
    NewFamily: "6A11A13D-05AB-4982-A4C2-67A8B1950C74",
    /** The oidc client detail page. */
    OidcClientDetail: "41E6A833-1697-4463-9962-01DFD123D4C9",
    /** The oidc clients page. */
    OidcClientList: "0A18B520-915E-429B-AC49-7A7F73B19BAA",
    /** The oidc give permission page. */
    OidcGivePermission: "73941D90-4CA1-46F8-A5D1-5B4BD2E53B3D",
    /** The oidc logout page. */
    OidcLogout: "FC20F56F-A7FB-4B89-9C66-98BC43816C8F",
    /** The oidc scope detail page. */
    OidcScopeDetail: "55E70873-B882-4864-8B97-66F8ED3588C7",
    /** The oidc scopes page. */
    OidcScopeList: "06FA872A-18B0-431A-917E-6F7B2EA8ED95",
    /**
     * Gets the Org Chart page guid
     * ParentPage: Office Information
     */
    OrgChart: "C3909F1A-6908-4035-BB93-EC4FBFDCC536",
    /**
     * Gets the Package Detail page guid
     * ParentPage: Rock Shop
     */
    PackageDetail: "D6DC6AFE-70D9-43CF-9D76-EAEE2317FB14",
    /**
     * Gets the Package Install page guid
     * ParentPage: Rock Shop
     */
    PackageInstall: "6029A6D6-0059-4CC1-9751-1F012BC267F1",
    /**
     * Gets the Packages By Category page guid
     * ParentPage: Rock Shop
     */
    PackagesByCategory: "50D17FE7-88DB-46B2-9C58-DF8C0DE376A4",
    /**
     * Gets the Page Map page guid
     * ParentPage: CMS Configuration
     */
    PageMap: "EC7A06CD-AAB5-4455-962E-B4043EA2440E",
    /**
     * Gets the Page Properties page guid
     * ParentPage: System Dialogs
     */
    PageProperties: "37759B50-DB4A-440D-A83B-4EF3B4727B1E",
    /**
     * Gets the Page Route Detail page guid
     * ParentPage: Routes
     */
    PageRouteDetail: "649A2B1E-7A15-4DA8-AF67-17874B6FE98F",
    /**
     * Gets the Page Map page guid
     * ParentPage: CMS Configuration
     */
    PageViews: "E556D6C5-E2DB-4041-81AB-4F582008155C",
    /**
     * Gets the People page guid
     * ParentPage: Internal Homepage
     */
    People: "97ECDC48-6DF6-492E-8C72-161F76AE111B",
    /**
     * Gets the Person Attributes page guid
     * ParentPage: General Settings
     */
    PersonAttributes: "7BA1FAF4-B63C-4423-A818-CC794DDB14E3",
    /**
     * Gets the Person Page Views page guid
     * ParentPage: Person Profile
     */
    PersonPageViews: "82E9CDDB-A60E-4C0E-9306-C07BEAAD5F70",
    /**
     * Gets the Person Pages page guid
     * ParentPage: Support Pages
     */
    PersonPages: "BF04BB7E-BE3A-4A38-A37C-386B55496303",
    /**
     * Gets the Person Profile page guid that is under Check-in Manager
     * ParentPage: Check-in Manager
     */
    PersonProfileCheckInManager: "F3062622-C6AD-48F3-ADD7-7F58E4BD4EF3",
    /**
     * Gets the Person Profile page guid
     * ParentPage: Person Pages
     */
    PersonProfilePersonPages: "08DBD8A5-2C35-4146-B4A8-0F7652348B25",
    /**
     * Gets the Person Search page guid
     * ParentPage: Support Pages
     */
    PersonSearch: "5E036ADE-C2A4-4988-B393-DAC58230F02E",
    /**
     * Gets the Person Select page guid
     * ParentPage: Check-in
     */
    PersonSelect: "BB8CF87F-680F-48F9-9147-F4951E033D17",
    /**
     * Gets the Person Viewed Detail page guid
     * ParentPage: Security
     */
    PersonViewedDetail: "48A9DF54-CC19-42FA-BDC6-97AF3E63029D",
    /** The phone number lookup page. */
    PhoneNumberLookup: "9F8D906F-ADB6-42AC-9777-D9712A5D097F",
    /**
     * Gets the Photo Opt-Out page guid
     * ParentPage: Support Pages
     */
    PhotoOptOut: "04141667-1A08-4E15-8BB7-E3E312233E11",
    /**
     * Gets the Photo Request Application Group page guid
     * ParentPage: Photo Requests
     */
    PhotoRequestApplicationGroup: "372BAF1A-F619-46FC-A69A-61E2A0A82F0E",
    /**
     * Gets the Photo Requests page guid
     * ParentPage: Data Integrity
     */
    PhotoRequests: "325B50D6-545D-461A-9CB7-72B001E82F21",
    /**
     * Gets the Photo Upload page guid
     * ParentPage: Support Pages
     */
    PhotoUpload: "8559A9F1-C6A4-4945-B393-74F6706A8FA2",
    /**
     * Gets the Pledge Detail page guid
     * ParentPage: Pledge List
     */
    PledgeDetail: "EF7AA296-CA69-49BC-A28B-901A8AAA9466",
    /**
     * Gets the Pledge List page guid
     * ParentPage: Functions
     */
    PledgeList: "1570D2AF-4FE2-4FC7-BED9-F20EBCBE9867",
    /**
     * Gets the Power Tools page guid
     * ParentPage: Rock Settings
     */
    PowerTools: "7F1F4130-CB98-473B-9DE1-7A886D2283ED",
    /** The PowerBI Account Registration Page */
    PowerbiAccountRegistration: "BB65848A-3EBD-D181-4150-956A39FFE57E",
    /**
     * Gets the Prayer Categories page guid
     * ParentPage: General Settings
     */
    PrayerCategories: "FA2A1171-9308-41C7-948C-C9EBEA5BD668",
    /**
     * Gets the Prayer page guid
     * ParentPage: Manage
     */
    PrayerManage: "1A3437C8-D4CB-4329-A366-8D6A4CBF79BF",
    /**
     * Gets the Prayer Request Detail page guid
     * ParentPage: Prayer
     */
    PrayerRequestDetail: "89C3DB4A-BAFD-45C8-88C6-45D8FEC48B48",
    /**
     * Gets the (Public) Create Pledge page guid
     * ParentPage: Pledge List
     */
    PublicCreatePledge: "60051DAF-2986-406D-A78B-1609CBF2256D",
    /**
     * Gets the Purchases page guid
     * ParentPage: Rock Shop
     */
    Purchases: "6A163569-2826-4EF2-8208-879DDBDC0896",
    /** The registration detail */
    RegistrationDetail: "FC81099A-2F98-4EBA-AC5A-8300B2FE46C4",
    /**
     * Gets the Registration Instance page guid
     * ParentPage: Event Registration
     */
    RegistrationInstance: "844DC54B-DAEC-47B3-A63A-712DD6D57793",
    /**
     * Gets the Registration Instance - Discounts page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceDiscounts: "6EE74759-D11B-4911-9BC8-CF23DE5534B2",
    /**
     * Gets the Registration Instance - Fees page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceFees: "B0576A70-CCB3-4E98-B6C4-3D758DD5F609",
    /** The registration instance linkage */
    RegistrationInstanceLinkage: "DE4B12F0-C3E6-451C-9E35-7E9E66A01F4E",
    /**
     * Gets the Registration Instance - Linkages page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceLinkages: "8C2C0EDB-60AD-4FA3-AEDA-45B972CA8CC5",
    /**
     * Gets the Registration Instance - Payments page guid
     * ParentPage: Event Registration
     */
    RegistrationInstancePayments: "562D6252-D614-4ED4-B602-D8160066611D",
    /**
     * Gets the Registration Instance - Placement Groups page guid
     * ParentPage: Event Registration
     */
    RegistrationInstancePlacementGroups: "0CD950D7-033D-42B1-A53E-108F311DC5BF",
    /**
     * Gets the Registration Instance - Registrants page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceRegistrants: "6138DA76-BD9A-4373-A55C-F88F155E1B13",
    /**
     * Gets the Registration Instance - Registrations page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceRegistrations: "844DC54B-DAEC-47B3-A63A-712DD6D57793",
    /**
     * Gets the Registration Instance - Wait List page guid
     * ParentPage: Event Registration
     */
    RegistrationInstanceWaitList: "E17883C2-6442-4AE5-B561-2C783F7F89C9",
    /** The registration send payment reminders */
    RegistrationSendPaymentReminders: "2828BBCF-B3FC-4707-B063-086748853978",
    /** The Registration Template Placement page guid */
    RegistrationTemplatePlacement: "02E7D8EC-E0F1-4632-9641-77772144A4CA",
    /** The registration wait list confirmation */
    RegistrationWaitListConfirmation: "4BF84D3F-DE7B-4F8B-814A-1E728E69C105",
    /**
     * Reminder Edit page.
     * ParentPage: Reminder List.
     */
    ReminderEdit: "2640FF34-DCC9-4604-9C5B-9E2DA590D5A7",
    /**
     * Reminder List page.
     * ParentPage: People &gt; Manage.
     */
    ReminderList: "E1736347-1D4F-42A6-8EC4-7595286054A6",
    /**
     * Reminder List page.
     * ParentPage: General Settings.
     */
    ReminderTypes: "3A2BA8F8-B119-4D3E-BE76-FEC81F7AC1BB",
    /**
     * Gets the Report Detail page guid
     * ParentPage: Reports
     */
    ReportDetail: "DB58BC69-01FA-4F3E-832B-B1D0DE915C21",
    /** The report search results page */
    ReportSearchResults: "7DA4B63B-4407-47B2-8984-A54A543D8A69",
    /**
     * Gets the Reporting page guid
     * ParentPage: Tools
     */
    Reporting: "BB0ACD18-24FB-42BA-B89A-2FFD80472F5B",
    /**
     * Gets the Reports page guid
     * ParentPage: Data Integrity
     */
    ReportsDataIntegrity: "134D8730-6AF5-4518-89EE-7370FA78676E",
    /**
     * Gets the Reports page guid
     * ParentPage: Reporting
     */
    ReportsReporting: "0FDF1F63-CFB3-4F8E-AC5D-A5312B522D6D",
    /**
     * Gets the REST Controller Actions page guid
     * ParentPage: REST Controllers
     */
    RestControllerActions: "7F5EF1AA-0E27-4AA1-A5E1-1CD6DDDCDDC5",
    /**
     * Gets the REST Controllers page guid
     * ParentPage: Security
     */
    RestControllers: "0D51F443-1C0D-4C71-8BAE-E5F5A35E8B79",
    /**
     * Gets the REST CORS Domains page guid
     * ParentPage: Security
     */
    RestCorsDomains: "B03A8C4E-E394-44B0-B7CC-89B74C79C325",
    /**
     * Gets the REST Key Detail page guid
     * ParentPage: REST Keys
     */
    RestKeyDetail: "594692AA-5647-4F9A-9488-AADB990FDE56",
    /**
     * Gets the REST Keys page guid
     * ParentPage: Security
     */
    RestKeys: "881AB1C2-4E00-4A73-80CC-9886B3717A20",
    /**
     * Gets the Rock Settings page guid
     * ParentPage: Admin Tools
     */
    RockSettings: "550A898C-EDEA-48B5-9C58-B20EC13AF13B",
    /**
     * Gets the Rock Shop page guid
     * ParentPage: Rock Settings
     */
    RockShop: "B093E7A0-5E7E-4A5F-AEF3-CE397D342BFA",
    /**
     * Gets the Rock Update page guid
     * ParentPage: General Settings
     */
    RockUpdate: "A3990266-CB0D-4FB5-882C-3852ED5D96AB",
    /**
     * Gets the Routes page guid
     * ParentPage: CMS Configuration
     */
    Routes: "4A833BE3-7D5E-4C38-AF60-5706260015EA",
    /**
     * Gets the Safe Sender Domains page guid
     * ParentPage: Communications
     */
    SafeSenderDomains: "B90576B0-110E-4DC0-8EB8-4668C5238508",
    /**
     * Gets the Sample Data page guid
     * ParentPage: Power Tools
     */
    SampleData: "844ABF2A-D085-4370-945B-86C89580C6D5",
    /**
     * Gets the Schedule Builder page guid
     * ParentPage: Check-in Configuration
     */
    ScheduleBuilder: "A286D16B-FDDF-4D89-B98F-D51188B611E6",
    /** The schedule confirmation page guid */
    ScheduleConfirmation: "EA14B522-E2A6-4CA7-8AF0-9CDF0B84C8CF",
    /**
     * Gets the Scheduled Job Detail page guid
     * ParentPage: Jobs Administration
     */
    ScheduledJobDetail: "E18AC09D-45CD-49CF-8874-157B32556B7D",
    /**
     * Gets the Scheduled Transaction page guid
     * ParentPage: Scheduled Transactions
     */
    ScheduledTransaction: "996F5541-D2E1-47E4-8078-80A388203CEC",
    /**
     * Gets the Scheduled Transactions page guid
     * ParentPage: Functions
     */
    ScheduledTransactions: "F23C5BF7-4F52-448F-8445-6BAEEE3030AB",
    /**
     * Gets the Schedules page guid
     * ParentPage: Check-in
     */
    SchedulesCheckIn: "AFFFB245-A0EB-4002-B736-A2D52DD692CF",
    /**
     * Gets the Schedules page guid
     * ParentPage: General Settings
     */
    SchedulesGeneralSettings: "F5D6D7DD-FD5F-494C-83DC-E2AF63C705D1",
    /**
     * Gets the Search page guid
     * ParentPage: Check-in
     */
    Search: "D47858C0-0E6E-46DC-AE99-8EC84BA5F45F",
    /**
     * Gets the Search Services page guid
     * ParentPage: System Settings
     */
    SearchServices: "1719F597-5BA9-458D-9362-9C3E558E5C82",
    /** Gets the Search Type page guid */
    SearchType: "3E0327B1-EE0E-41DC-87DB-C4C14922A7CA",
    /**
     * Gets the Security page guid
     * ParentPage: Admin Tools
     */
    SecurityAdminTools: "8C71A7E2-18A8-41C0-AB40-AD85CF90CA81",
    /**
     * Gets the Security page guid
     * ParentPage: Person Pages
     */
    SecurityPersonPages: "0E56F56E-FB32-4827-A69A-B90D43CB47F5",
    /**
     * Gets the Security page guid
     * ParentPage: Rock Settings
     */
    SecurityRockSettings: "91CCB1C9-5F9F-44F5-8BE2-9EC3A3CFD46F",
    /**
     * Gets the Security Roles page guid
     * ParentPage: Security
     */
    SecurityRoles: "D9678FEF-C086-4232-972C-5DBAC14BFEE6",
    /**
     * Gets the Security Roles Detail page guid
     * ParentPage: Security Roles
     */
    SecurityRolesDetail: "48AAD428-A9C9-4BBB-A80F-B85F28D31240",
    /**
     * Gets the Security page guid
     * ParentPage: System Dialogs
     */
    SecuritySystemDialogs: "86D5E33E-E351-4CA5-9925-849C6C467257",
    /**
     * Gets the Send Photo Requests page guid
     * ParentPage: Communications
     */
    SendPhotoRequests: "B64D0429-488C-430E-8C32-5C7F32589F73",
    /**
     * Gets the short link page GUID
     * ParentPage: System Dialogs
     */
    ShortLink: "A9188D7A-80D9-4865-9C77-9F90E992B65C",
    /**
     * Gets the Sites page guid
     * ParentPage: CMS Configuration
     */
    Sites: "7596D389-4EAB-4535-8BEE-229737F46F44",
    /**
     * The SMS phone numbers
     * ParentPage: Communications
     */
    SmsPhoneNumbers: "3F1EA6E5-6C61-444A-A80E-5B66F96F521B",
    /**
     * Gets the SQL Command page guid
     * ParentPage: Power Tools
     */
    SqlCommand: "03C49950-9C4C-4668-9C65-9A0DF43D1B33",
    /**
     * Gets the Step Flow page guid
     * ParentPage: Engagement
     */
    StepFlow: "A5FE5D33-C9E2-496D-AD8F-5B7AA496B2AC",
    /**
     * Gets the Step Program Detail page guid
     * ParentPage: Step Programs
     */
    StepProgramDetail: "6E46BC35-1FCB-4619-84F0-BB6926D2DDD5",
    /**
     * Gets the Step Programs page guid
     * ParentPage: Engagement
     */
    StepPrograms: "F5E8A369-4856-42E5-B187-276DFCEB1F3F",
    /**
     * Gets the Streak page guid
     * ParentPage: Streak Type Detail
     */
    Streak: "488BE67C-EDA0-489E-8D80-8CC67F5854D4",
    /**
     * Gets the Streak Type Detail page guid
     * ParentPage: Streak Types
     */
    StreakTypeDetail: "CA566B33-0265-45C5-B1B2-6FFA6D4743F4",
    /**
     * Gets the Streak Type Detail page guid
     * ParentPage: Streak Type Detail
     */
    StreakTypeExclusionDetail: "68EF459F-5D23-4930-8EA8-80CDF986BB94",
    /**
     * Gets the Streak Types page guid
     * ParentPage: Engagement
     */
    StreakTypes: "F81097ED-3C96-45F2-A4F8-7D4D4F3D17F3",
    /**
     * Gets the Success page guid
     * ParentPage: Check-in
     */
    Success: "E08230B8-35A4-40D6-A0BB-521418314DA9",
    /**
     * Gets the Support Pages page guid (external site)
     * ParentPage: External Site
     */
    SupportPagesExternalSite: "EBAA5140-4B8F-44B8-B1E8-C73B654E4B22",
    /**
     * Gets the Support Pages page guid (internal site)
     * ParentPage: Internal Homepage
     */
    SupportPagesInternalHomepage: "936C90C4-29CF-4665-A489-7C687217F7B8",
    /**
     * Gets the System Communications page guid
     * ParentPage: Communications
     */
    SystemCommunicationDetail: "2FE2D59E-2737-49C8-AF1B-4366A8371A8E",
    /**
     * Gets the System Communications page guid
     * ParentPage: Communications
     */
    SystemCommunicationList: "14D8F894-F70F-44F7-9F0C-2545F87256FF",
    /** The system communication preview internal page. */
    SystemCommunicationPreview: "FD8E0C71-9543-4CAB-9918-76A67EFE5093",
    /**
     * Gets the System Configuration page guid
     * ParentPage: System Settings
     */
    SystemConfiguration: "7BFD28F2-6B90-4191-B7C1-2CDBFA23C3FA",
    /**
     * Gets the System Dialogs page guid
     * ParentPage: Internal Homepage
     */
    SystemDialogs: "E7BD353C-91A6-4C15-A6C8-F44D0B16D16E",
    /**
     * Gets the System Email Categories page guid
     * ParentPage: Communications
     */
    SystemEmailCategoriesCommunications: "B55323CD-F494-43E7-97BF-4E13DAB58E0B",
    /**
     * Gets the System Email Categories page guid
     * ParentPage: System Emails
     */
    SystemEmailCategoriesSystemEmails: "66FAF7A6-7523-475C-A88D-51C75178A785",
    /**
     * Gets the System Email Details page guid
     * ParentPage: System Emails
     */
    SystemEmailDetails: "588C72A8-7DEC-405F-BA4A-FE64F87CB817",
    /**
     * Gets the System Emails page guid
     * ParentPage: Communications
     */
    SystemEmails: "89B7A631-EA6F-4DA3-9380-04EE67B63E9E",
    /**
     * Gets the System Information page guid
     * ParentPage: System Dialogs
     */
    SystemInformation: "8A97CC93-3E93-4286-8440-E5217B65A904",
    /**
     * Gets the System Settings page guid
     * ParentPage: Rock Settings
     */
    SystemSettings: "C831428A-6ACD-4D49-9B2D-046D399E3123",
    /**
     * Gets the Tag page guid
     * ParentPage: Tags
     */
    Tag: "F3BD2F37-F16A-4C98-8A4C-C14A16AAFA3A",
    /**
     * Gets the Tag Details page guid
     * ParentPage: Tags
     */
    TagDetails: "D258BF5B-B585-4C5B-BDCD-99F7519D45E2",
    /**
     * Gets the Tags page guid
     * ParentPage: General Settings
     */
    TagsGeneralSettings: "F111791B-6A58-4388-8533-00E913F48F41",
    /**
     * Gets the Tags page guid
     * ParentPage: Manage
     */
    TagsManage: "2654EBE9-F585-4E64-93F3-102357F89660",
    /** Gets the Text To Give Setup page guid */
    TextToGiveSetup: "B7FE949A-B4B0-4AA7-B9E9-8818E7352CD1",
    /**
     * Gets the Time Select page guid
     * ParentPage: Check-in
     */
    TimeSelect: "C0AFA081-B64E-4006-BFFC-A350A51AE4CC",
    /**
     * Gets the Tools page guid
     * ParentPage: Internal Homepage
     */
    Tools: "98163C8B-5C91-4A68-BB79-6AD948A604CE",
    /**
     * Gets the Transaction Detail page guid
     * ParentPage: Financial Batch Detail
     */
    TransactionDetailFinancialBatchDetail: "97716641-D003-4663-9EA2-D9BB94E7955B",
    /**
     * Gets the Transaction Detail page guid
     * ParentPage: Transactions
     */
    TransactionDetailTransactions: "B67E38CB-2EF1-43EA-863A-37DAA1C7340F",
    /**
     * Gets the Transaction Matching page guid
     * ParentPage: Financial Batch Detail
     */
    TransactionMatching: "CD18FE52-8D6A-49C9-81BF-DF97C5BA0302",
    /**
     * Gets the Transactions page guid
     * ParentPage: Functions
     */
    Transactions: "7CA317B5-5C47-465D-B407-7D614F2A568F",
    /**
     * Gets the User Accounts page guid
     * ParentPage: Security
     */
    UserAccounts: "306BFEF8-596C-482A-8DEC-34A7B622E688",
    /**
     * Gets the Verify Photos page guid
     * ParentPage: Photo Requests
     */
    VerifyPhotos: "07E4BA19-614A-42D0-9D75-DFB31374844D",
    /**
     * The web farm
     * Parent page: System settings
     */
    WebFarm: "249BE98D-9DDE-4B19-9D97-9C76D9EA3056",
    /**
     * The web farm node
     * Parent page: Web Farm
     */
    WebFarmNode: "63698D5C-7C73-44A4-A27D-A7EB777EB2A2",
    /**
     * Gets the Website page guid
     * ParentPage: Tools
     */
    Website: "F7105BFE-B28C-41B6-9CE6-F1018D77DD8F",
    /**
     * Gets the Check-in Welcome page guid
     * ParentPage: Check-in
     */
    Welcome: "432B615A-75FF-4B14-9C99-3E769F866950",
    /**
     * Gets the Workflow page guid
     * ParentPage: Tools
     */
    Workflow: "CDB27DB2-977C-415A-AED5-D0751DFD5DF2",
    /**
     * Gets the Workflow Configuration page guid
     * ParentPage: General Settings
     */
    WorkflowConfiguration: "DCB18A76-6DFF-48A5-A66E-2CAA10D2CA1A",
    /**
     * Gets the Workflow Detail page guid
     * ParentPage: Manage Workflows
     */
    WorkflowDetail: "BA547EED-5537-49CF-BD4E-C583D760788C",
    /**
     * Gets the Workflow Entry page guid
     * ParentPage: Workflows
     */
    WorkflowEntry: "0550D2AA-A705-4400-81FF-AB124FDF83D7",
    /**
     * Gets the Workflow Trigger page guid
     * ParentPage: Workflow Triggers
     */
    WorkflowTrigger: "04D844EA-7780-427B-8912-FA5EB7C74439",
    /**
     * Gets the Workflow Triggers page guid
     * ParentPage: General Settings
     */
    WorkflowTriggers: "1A233978-5BF4-4A09-9B86-6CC4C081F48B",
    /**
     * Gets the Workflows page guid
     * ParentPage: Data Integrity
     */
    WorkflowsDataIntegrity: "90C32D5E-A5D5-4CE4-AAB0-E31B43B585E4",
    /**
     * Gets the Workflows page guid
     * ParentPage: Workflow
     */
    WorkflowsWorkflow: "6510AB6B-DFB4-4DBF-9F0F-7EA598E4AC54",
    /**
     * Gets the ZoneBlocks page guid
     * ParentPage: System Dialogs
     */
    Zoneblocks: "9F36531F-C1B5-4E23-8FA3-18B6DAFF1B0B",
};
